import axios, { AxiosResponse } from 'axios'
import { AuthUser } from 'contexts/auth/interface'
import { environments } from 'environments/environments'
import {
    AuthRequestChangePassword,
    AuthRequestDTO,
    AuthRequestForgotPassword,
    AuthRequestResetPassword,
    RefreshTokenRequestDTO
} from 'models'
import {
    CertificateAuthenticationRequest,
    CertificateChallengeResponse
} from 'models/CertificateAuthenticationDTO'
import { SignOutDTO } from 'models/SignOutDTO'
import api from './api'

const {
    ENDPOINT_API_AUTH,
    ENDPOINT_API_USERS
} = environments

const refreshApi = axios.create()

export const signIn = async (
    data: AuthRequestDTO
): Promise<AxiosResponse<any>> => {
    const dataAuth = await api.post(
        `${ENDPOINT_API_AUTH}/auth/signin`,
        data
    )

    api.defaults.headers.common[
        'Authorization'
    ] = `Bearer ${dataAuth.data.idToken}`

    return dataAuth
}

export const createCertificateChallenge = async (): Promise<
    AxiosResponse<CertificateChallengeResponse>
> => {
    return api.post(
        `${ENDPOINT_API_USERS}/auth/certificado/desafio`
    )
}

export const signInWithCertificate = async (
    data: CertificateAuthenticationRequest
): Promise<AxiosResponse<AuthUser>> => {
    const dataAuth = await api.post(
        `${ENDPOINT_API_USERS}/auth/certificado/signin`,
        data
    )

    api.defaults.headers.common[
        'Authorization'
    ] = `Bearer ${dataAuth.data.idToken}`

    return dataAuth
}

export const signUp = async (
    data: AuthRequestDTO
): Promise<void> => {
    return api.post(
        `${ENDPOINT_API_AUTH}/auth/signup`,
        data
    )
}

export const mfaConfirm = async (data: any) => {
    return api.post(
        `${ENDPOINT_API_USERS}/oauth2/mfa/verify-sms-mfa`,
        data
    )
}

export const mfaResendCode = async (data: any) => {
    return api.post(
        `${ENDPOINT_API_USERS}/oauth2/mfa/resend-code`,
        data
    )
}

export const signOut = async (
    data: SignOutDTO
): Promise<void> => {
    return api.post(
        `${ENDPOINT_API_AUTH}/auth/logout`,
        data
    )
}

export const validateCaptcha = async (
    token: string
): Promise<void> => {
    return api.post(
        `${ENDPOINT_API_AUTH}/auth/captcha-confirm`,
        {},
        {
            headers: {
                'X-ERDOC-CAPTCHA': token
            }
        }
    )
}

export const refreshToken = async (
    data: RefreshTokenRequestDTO
): Promise<AxiosResponse<AuthUser>> => {
    const idToken = sessionStorage.getItem('idToken')
    return refreshApi.post(
        `${ENDPOINT_API_AUTH}/auth/refresh-token`,
        data,
        {
            headers: idToken
                ? {
                    Authorization: `Bearer ${idToken}`
                }
                : undefined
        }
    )
}

export const resetPassword = async (
    data: AuthRequestResetPassword
): Promise<AxiosResponse<void>> => {
    return api.post(
        `${ENDPOINT_API_AUTH}/auth/reset-password`,
        data
    )
}

export const changePassword = async (
    data: AuthRequestChangePassword
): Promise<AxiosResponse<void>> => {
    return api.post(
        `${ENDPOINT_API_USERS}/auth/alter-password`,
        data
    )
}

export const forgotPassword = async (
    data: AuthRequestForgotPassword
): Promise<AxiosResponse<void>> => {
    return api.post(
        `${ENDPOINT_API_AUTH}/auth/forgot-password`,
        data
    )
}

export const state = async (
    currentUser: AuthUser | undefined
): Promise<boolean> => {
    return new Promise(resolve =>
        setTimeout(
            () =>
                resolve(
                    currentUser?.idToken
                        ? true
                        : false
                ),
            1000
        )
    )
}

const Auth = {
    signIn,
    signInWithCertificate,
    createCertificateChallenge,
    signUp,
    signOut,
    validateCaptcha,
    refreshToken,
    resetPassword,
    forgotPassword,
    state,
    changePassword,
    mfaConfirm,
    mfaResendCode
}

export default Auth